// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2WYJG","clinicsSelect":"TableHeading_clinicsSelect__2I9yC"};